import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useStytchOrganization } from '@stytch/react/b2b'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { gridsQueryKey } from './useGrids'
import { gridVersionsQueryKey } from './useGridVersions'

import type { Grid, GridVersion, GridVersionPayload, Workspace } from 'honeygrid-types'

interface CreateGridVersionParams {
	workspaceId?: Workspace['uuid']
	gridId: Grid['uuid']
	version: Partial<GridVersionPayload>
}

export const useCreateGridVersion = () => {
	const queryClient = useQueryClient()
	const authFetch = useHoneyGridApiFetch()
	const { organization } = useStytchOrganization()

	return useMutation({
		mutationFn: ({ gridId, version }: CreateGridVersionParams) =>
			authFetch(`workspaces/${organization?.organization_id}/grids/${gridId}/versions`, {
				method: 'POST',
				body: version,
			}) as Promise<GridVersion>,
		onSuccess: (_, { gridId }) => {
			// Invalidate grids list for workspace
			queryClient.invalidateQueries({
				queryKey: gridsQueryKey(organization?.organization_id ?? ''),
			})
			// Invalidate grid versions for this specific grid
			queryClient.invalidateQueries({
				queryKey: gridVersionsQueryKey(organization?.organization_id ?? '', gridId),
			})
		},
	})
}
